import Header from "../../commons/header";
import Footer from "../../commons/footer"
import EducationMain from "./main";

const Education = () => {
    return(
        <>
            <Header />
            <EducationMain />
            <Footer />
        </>
    )
};

export default Education;